import { initContract } from '@ts-rest/core'
import { GetDeliveriesResponseSchema } from '@repo/api-types'
import { ErrorResponseSchema } from './general'

const c = initContract()

export const deliveryContract = c.router(
  {
    getDeliveries: {
      method: 'GET',
      path: '/deliveries',
      responses: {
        200: GetDeliveriesResponseSchema,
      },
    },
  },
  {
    commonResponses: {
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema,
    },
  },
)
